export default __webpack_public_path__ + "static/media/somhero.64878570.jpg";